// extracted by mini-css-extract-plugin
export var active = "br10-1";
export var categoryM = "br10-W";
export var categoryMFixed = "br10-da";
export var categoryMName = "br10-X";
export var categoryProduct = "br10-4";
export var categoryProductImg = "br10-5";
export var categoryProductName = "br10-6";
export var categoryProductOrigin = "br10-7";
export var categoryProductPrice = "br10-8";
export var categoryProductPriceCn = "br10-9";
export var categoryProductPriceEn = "br10-aa";
export var categoryProductSaleView = "br10-ca";
export var categoryProductTag = "br10-ba";
export var categorySection = "br10-3";
export var filterChoose = "br10-_";
export var filterContent = "br10-Y";
export var filterItem = "br10--";
export var filterItemText = "br10-0";
export var filterList = "br10-2";
export var minWidthLimit = "br10-V";
export var searchMoreKeywords = "br10-ea";
export var searchMoreKeywordsList = "br10-ga";
export var searchMoreKeywordsTitle = "br10-fa";
export var searchRelatedArticles = "br10-ha";
export var searchRelatedArticlesTitle = "br10-ia";
export var toLeft = "br10-Z";